import tw from 'twin.macro';
import styled from 'styled-components';

export const PageWrapper = tw.div`pt-4`;

// general styles for all forms
export const Form = styled.form`
  ${({ isGrird }: { isGrird?: boolean }) => (isGrird ? tw`grid grid-cols-2 gap-20` : '')}
  ${tw`pr-10 2xl:pr-16 pb-10`}
`;

export const InputWrap = tw.div`flex flex-col`;

export const Label = tw.label`font-normal mb-3`;

export const Input = styled.input`
  ${({ isGrird }: { isGrird?: boolean }) => (isGrird ? tw`w-full` : tw`w-3/5 pl-6!`)}
  ${tw`p-3 font-thin bg-gray-200`}
`;

export const SelectInput = tw.select`p-3 w-full font-thin bg-gray-200`;

export const SelectOption = tw.option`my-2`;

export const InputErrMess = tw.p`text-red-600 mt-1`;

export const Submit = tw.button`py-3 px-10 rounded-lg font-bold text-white bg-adminprimary`;

export const Clear = tw.button`rounded-lg py-3 px-16 font-bold text-adminprimary
 bg-white border border-blue-500`;

export const SelectCourseOption = styled.div`
  ${({ isChecked }: { isChecked: boolean }) => (isChecked ? tw`bg-blue-200` : tw`bg-blue-100`)}
  ${tw`flex items-center hover:bg-blue-300 transition-all hover:py-4 duration-150 transform
   cursor-pointer flex-1 p-3 gap-2 rounded-md`}
`;
